import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import BackgroundImage from '../background-image/background-image';
import type { ContentElement as Props } from './content-element.types';

const ContentElement: React.FunctionComponent<Props> = ({
  description,
  image,
  small,
  tall,
  title,
}) => (
  <div
    className={cn('content-element', { 'content-element--tall': tall })}
    tabIndex={0}
  >
    <div
      className={cn('content-element__inner', {
        'content-element__inner--small': small,
      })}
    >
      <div className="content-element__image">
        <BackgroundImage {...image} />
        <div className="content-element__image-minimum" />
      </div>
      <div className="content-element__content">
        <Text
          elementName="h3"
          size={Text.sizes.headline3}
          theme={Text.themes.emphasis}
          tight
        >
          {title}
        </Text>
        <Text elementName="p" tight>
          {description}
        </Text>
      </div>
    </div>
  </div>
);

export default ContentElement;
